import { withJsonFormsControlProps } from "@jsonforms/react";

import { ColorPickerInput } from "../../../color";

export const JsonColorPicker = withJsonFormsControlProps(({ data, label, path, handleChange }) => (
  <>
    <div>{label}</div>
    <ColorPickerInput onChange={(value) => handleChange(path, value)} value={data} />
  </>
));
